(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9939,9831],{

/***/ 3542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(2223);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ reviewComponent; },
/* harmony export */   "ZP": function() { return /* binding */ ReviewsLanding; },
/* harmony export */   "il": function() { return /* binding */ SingleReview; }
/* harmony export */ });
/* unused harmony exports reviewSchema, SingleReviewDesktop */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _comps_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9612);
/* harmony import */ var react_styled_flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4382);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1604);
/* harmony import */ var _utils_cdn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(177);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4773);








var reviewSchema = zod__WEBPACK_IMPORTED_MODULE_5__.z.object({
    name: zod__WEBPACK_IMPORTED_MODULE_5__.z.string(),
    opinion: zod__WEBPACK_IMPORTED_MODULE_5__.z.string(),
    rating: zod__WEBPACK_IMPORTED_MODULE_5__.z.number(),
    avatar: zod__WEBPACK_IMPORTED_MODULE_5__.z.string()
});
var reviewComponent = zod__WEBPACK_IMPORTED_MODULE_5__.z.object({
    component: zod__WEBPACK_IMPORTED_MODULE_5__.z.literal("reviews"),
    title: zod__WEBPACK_IMPORTED_MODULE_5__.z.string(),
    subtitle: zod__WEBPACK_IMPORTED_MODULE_5__.z.string().optional(),
    without_background: zod__WEBPACK_IMPORTED_MODULE_5__.z.boolean().optional(),
    reviews: zod__WEBPACK_IMPORTED_MODULE_5__.z.array(reviewSchema)
});
function ReviewsLanding(props) {
    var reviews = props.reviews, title = props.title, subtitle = props.subtitle, without_background = props.without_background;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), offset = ref[0], setOffset = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "relative w-full py-[35px] tablet:py-[40px] desktop:py-[55px]",
            children: [
                !without_background && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pointer-events-none absolute right-0 top-0 w-full -translate-y-1/4 overflow-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_comps_image__WEBPACK_IMPORTED_MODULE_1__/* .ResponsiveImage */ .t3, {
                        src: "/feature/background",
                        className: "w-full object-fill dark:opacity-40"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative flex w-full flex-col items-center gap-4 text-center tablet:gap-[26px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-[26px] font-800 leading-tight text-blue-900 tablet:text-[26px] desktop:text-[52px]",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-body-3 desktop:max-w-[800px]",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "relative hidden w-[1165px] flex-row desktop:flex desktop:items-center desktop:justify-center desktop:gap-3",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: offset === 0,
                                    onClick: function() {
                                        return setOffset(offset - 1);
                                    },
                                    className: "absolute left-0 z-20 hidden h-[50px] w-[50px] -translate-x-1/2 rotate-180 flex-row items-center justify-center rounded-full bg-color-cell shadow-2xl shadow-[#B7B7B70C] transition-colors inner-border inner-border-color-separator hover:bg-blue-100 disabled:opacity-0 desktop:flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "relative z-0 w-full desktop:h-[350px]",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "no-scrollbar absolute left-0 top-0 hidden w-full flex-row gap-5 overflow-x-scroll px-4 tablet:gap-4 tablet:px-5 desktop:flex desktop:h-[550px] desktop:w-full desktop:gap-6 desktop:overflow-x-hidden desktop:px-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                left: "-".concat(offset * 395, "px")
                                            },
                                            className: "absolute top-0 hidden gap-5 transition-all duration-300 desktop:flex desktop:flex-row",
                                            children: reviews.map(function(review, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleReviewDesktop, {
                                                    review: review,
                                                    without_background: without_background,
                                                    avatar: review.avatar
                                                }, index);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    disabled: offset + 3 === reviews.length,
                                    onClick: function() {
                                        return setOffset(offset + 1);
                                    },
                                    className: "absolute right-0 z-20 hidden h-[50px] w-[50px] translate-x-1/2 flex-row items-center justify-center rounded-full bg-color-cell shadow-2xl shadow-[#B7B7B70C] transition-colors inner-border inner-border-color-separator hover:bg-blue-100 disabled:opacity-0 desktop:flex",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "no-scrollbar flex w-full flex-row gap-5 overflow-x-scroll px-4 tablet:gap-4 tablet:px-5 desktop:hidden",
                            children: reviews.map(function(review, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SingleReview, {
                                    review: review,
                                    without_background: without_background,
                                    avatar: review.avatar
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
}
function SingleReview(props) {
    var avatar = props.avatar, review = props.review, without_background = props.without_background;
    var name = review.name, rating = review.rating, opinion = review.opinion;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-20 flex shrink-0 flex-col items-center gap-4 rounded-[12px] border border-color-separator px-5 py-4 tablet:px-[26px] tablet:py-10 desktop:w-[375px]", without_background ? "bg-blue-cell" : "bg-color-cell"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: avatar,
                    alt: name,
                    className: "h-[62px] w-[62px] rounded-full object-cover tablet:h-[122px] tablet:w-[122px] desktop:h-[62px] desktop:w-[62px]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " text-2xl font-700",
                    children: name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexItem */ .B5, {
                    box: true,
                    gap: 8,
                    alignSelf: "center",
                    children: Array(5).fill(0).map(function(_, i) {
                        return i < rating ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-full.svg"),
                            alt: "star icon"
                        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-empty.svg"),
                            alt: "star icon"
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "line-clamp-3 w-[229px] px-2 text-base font-400 text-color-placeholder tablet:px-0 desktop:w-[350px]",
                    children: "“".concat(opinion, "”")
                })
            ]
        })
    });
}
function SingleReviewDesktop(props) {
    var avatar = props.avatar, review = props.review, without_background = props.without_background;
    var name = review.name, rating = review.rating, opinion = review.opinion;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("relative z-20 flex shrink-0 flex-col items-center gap-4 rounded-[12px] border border-color-separator px-5 py-4 tablet:px-[26px] tablet:py-10 desktop:w-[375px]", without_background ? "bg-blue-cell" : "bg-color-cell"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: avatar,
                    alt: name,
                    className: "h-[62px] w-[62px] rounded-full object-cover tablet:h-[122px] tablet:w-[122px] desktop:h-[62px] desktop:w-[62px]"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " text-2xl font-700",
                    children: name
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_styled_flex__WEBPACK_IMPORTED_MODULE_2__/* .FlexItem */ .B5, {
                    box: true,
                    gap: 8,
                    alignSelf: "center",
                    children: Array(5).fill(0).map(function(_, i) {
                        return i < rating ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-full.svg"),
                            alt: "star icon"
                        }, i) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: (0,_utils_cdn__WEBPACK_IMPORTED_MODULE_7__/* .assetUrl */ .p)("/comps/star-empty.svg"),
                            alt: "star icon"
                        }, i);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tooltip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "w-[229px] px-2 tablet:px-0 desktop:w-full",
                    showAlways: opinion.length > 165,
                    title: "“".concat(opinion, "”"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: " adesktop:w-[350px] aw-[229px] line-clamp-4 w-full text-base font-400 text-blue-600",
                        children: "“".concat(opinion, "”")
                    })
                })
            ]
        })
    });
}
var Arrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "11",
        height: "18",
        viewBox: "0 0 11 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M1.56961 1.36114L9.2085 9.00003L1.56961 16.6389",
            stroke: "#575757",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};


/***/ }),

/***/ 2223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Pricing; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(7582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./comps/feature/reviews.tsx
var reviews = __webpack_require__(7544);
// EXTERNAL MODULE: ./comps/footer/index.tsx + 4 modules
var footer = __webpack_require__(8109);
// EXTERNAL MODULE: ./comps/header/index.tsx + 2 modules
var header = __webpack_require__(1083);
// EXTERNAL MODULE: ./comps/home/platforms/runner.tsx
var runner = __webpack_require__(4593);
// EXTERNAL MODULE: ./comps/message.tsx
var message = __webpack_require__(9034);
// EXTERNAL MODULE: ./comps/meta.tsx
var meta = __webpack_require__(624);
// EXTERNAL MODULE: ./utils/adjust.tsx + 1 modules
var adjust = __webpack_require__(6254);
// EXTERNAL MODULE: ./utils/cdn.ts
var cdn = __webpack_require__(177);
// EXTERNAL MODULE: ./utils/client-auth.tsx
var client_auth = __webpack_require__(1816);
// EXTERNAL MODULE: ./comps/subscription-popup.tsx + 1 modules
var subscription_popup = __webpack_require__(9460);
// EXTERNAL MODULE: ./utils/notification.tsx
var notification = __webpack_require__(4371);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 40 modules
var axios = __webpack_require__(6154);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 34 modules
var esm = __webpack_require__(2213);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./comps/button.tsx
var comps_button = __webpack_require__(5896);
// EXTERNAL MODULE: ./comps/toggle.tsx
var toggle = __webpack_require__(7092);
;// CONCATENATED MODULE: ./sections/pricing/compare.tsx








function Compare(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var sections = props.sections, isYearly = props.isYearly, setIsMonthly = props.setIsMonthly, handlePurchaseClick = props.handlePurchaseClick, savePercent = props.savePercent, basic = props.basic, advanced = props.advanced;
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    var ref6 = (0,subscription_popup/* getCurrentPackId */.V2)(userInfo.entitlements), currentPackId = ref6.packId;
    var yearlyPricePro = ((ref = basic.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref === void 0 ? void 0 : ref.price) || 0;
    var yearlyPriceDividedPro = yearlyPricePro / 12;
    var yearlyPriceFormattedPro = Math.floor(yearlyPriceDividedPro);
    var yearlyPriceAdvanced = ((ref1 = advanced.variants[0].periods.find(function(a) {
        return a.period === "yearly";
    })) === null || ref1 === void 0 ? void 0 : ref1.price) || 0;
    var yearlyPriceDividedAdvanced = yearlyPriceAdvanced / 12;
    var yearlyPriceFormattedAdvanced = Math.floor(yearlyPriceDividedAdvanced);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("flex flex-col items-center justify-center gap-[22px] tablet:mt-[40px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (0,clsx_m/* default */.Z)("text-[20px] font-700 leading-[24px] tracking-[0.4px] text-blue-900", "tablet:text-[24px] tablet:leading-[36px] tablet:tracking-[0.48px]", "pt-[50px] desktop:text-[32px] desktop:tracking-[0.64px]"),
                children: t("txt_compare")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex w-full flex-row gap-2 px-4 tablet:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " flex w-full items-center justify-center gap-[10px] tablet:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-500" : "text-blue-900", "text-[18px] font-500 transition-colors"),
                            children: t("txt_monthly")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle/* SquareSwitch */.ZP, {
                            onChange: setIsMonthly,
                            enabled: isYearly
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-900" : "text-blue-500", "text-[18px] font-500 transition-colors "),
                            children: t("txt_yearly")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (0,clsx_m/* default */.Z)("text-[18px] font-500 transition-colors", isYearly ? "text-blue-900" : "text-blue-500"),
                            children: t("fs_save_percent", {
                                percent: String(savePercent)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex w-full flex-col rounded-[12px] desktop:w-[975px]", "px-4 tablet:px-5 desktop:px-0"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)("z-20 w-full pt-[20px]", "sticky bottom-[100px] top-[29px] bg-color-background tablet:top-[50px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex w-full flex-row items-center justify-between rounded-t-[12px] border-b border-color-separator bg-color-cell",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "ml-[50px] hidden w-[130px] flex-col tablet:flex",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (0,clsx_m/* default */.Z)("text-[18px] font-500 text-blue-900"),
                                                    children: isYearly ? t("txt_yearly") : t("txt_monthly")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle/* SquareSwitch */.ZP, {
                                                    onChange: setIsMonthly,
                                                    enabled: isYearly
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-800" : "text-blue-500", "text-[18px] font-500 transition-colors duration-200"),
                                            children: t("fs_save_percent", {
                                                percent: String(savePercent)
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex w-full flex-row justify-between tablet:w-auto tablet:justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-1 flex-col items-center gap-2 rounded-t-[12px] border-2 border-b-0 border-green-400 px-2 py-3 tablet:w-[170px] tablet:px-5 tablet:py-7 desktop:w-[209px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] font-500 text-blue-900",
                                                    children: "Pro + AI"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative h-[20px] w-full overflow-hidden",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[20px] w-full flex-row items-end justify-center gap-[2px]", isYearly && "-top-6", "transition-all duration-500"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: (0,clsx_m/* default */.Z)("font-700 text-blue-800", "text-[14px]"),
                                                                    children: [
                                                                        "$",
                                                                        String((ref2 = basic.variants[0].periods.find(function(a) {
                                                                            return a.period === "monthly";
                                                                        })) === null || ref2 === void 0 ? void 0 : ref2.price).slice(0, -2),
                                                                        ".",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            children: String((ref3 = basic.variants[0].periods.find(function(a) {
                                                                                return a.period === "monthly";
                                                                            })) === null || ref3 === void 0 ? void 0 : ref3.price).slice(-2)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "font-300 mb-[2px] text-[10px] lowercase text-blue-500",
                                                                    children: [
                                                                        "/",
                                                                        t("txt_month")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[20px] w-full flex-row items-end justify-center gap-[2px]", !isYearly && "top-6", "transition-all duration-500"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: (0,clsx_m/* default */.Z)("font-700 text-blue-900", "text-[14px]"),
                                                                    children: [
                                                                        "$",
                                                                        String(yearlyPriceFormattedPro).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedPro).slice(0, -2) : 0,
                                                                        ".",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            children: String(yearlyPriceFormattedPro).slice(-2)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "font-300 mb-[2px] text-[10px] lowercase text-blue-600",
                                                                    children: [
                                                                        "/",
                                                                        t("txt_month"),
                                                                        "*"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* GradientGrayscaleButton */.sH, {
                                                    small: true,
                                                    grayscale: true,
                                                    disabled: (0,subscription_popup/* getBasicButtonText */.hv)(currentPackId) === "txt_current_plan",
                                                    onClick: function() {
                                                        return handlePurchaseClick(basic.variants[0].pack_id);
                                                    },
                                                    className: "flex h-10 w-full items-center justify-center !text-[12px] disabled:!bg-green-100 disabled:!text-color-inactive-text disabled:hover:!bg-green-100 tablet:!text-[15px] desktop:w-[170px]",
                                                    text: (0,subscription_popup/* getBasicButtonText */.hv)(currentPackId)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-1 flex-col items-center gap-2 px-2 py-3 tablet:w-[170px] tablet:px-5 tablet:py-7 desktop:w-[209px]",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[18px] font-500 text-blue-900",
                                                    children: "Advanced + AI"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative h-[20px] w-full overflow-hidden",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[20px] w-full flex-row items-end justify-center gap-[2px]", isYearly && "-top-6", "transition-all duration-500"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: (0,clsx_m/* default */.Z)("font-700 text-blue-800", "text-[14px]"),
                                                                    children: [
                                                                        "$",
                                                                        String((ref4 = advanced.variants[0].periods.find(function(a) {
                                                                            return a.period === "monthly";
                                                                        })) === null || ref4 === void 0 ? void 0 : ref4.price).slice(0, -2),
                                                                        ".",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            children: String((ref5 = advanced.variants[0].periods.find(function(a) {
                                                                                return a.period === "monthly";
                                                                            })) === null || ref5 === void 0 ? void 0 : ref5.price).slice(-2)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "font-300 mb-[2px] text-[10px] lowercase text-blue-500",
                                                                    children: [
                                                                        "/",
                                                                        t("txt_month")
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (0,clsx_m/* default */.Z)("absolute inset-0", "flex h-[20px] w-full flex-row items-end justify-center gap-[2px]", !isYearly && "top-6", "transition-all duration-500"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: (0,clsx_m/* default */.Z)("font-700 text-blue-900", "text-[14px]"),
                                                                    children: [
                                                                        "$",
                                                                        String(yearlyPriceFormattedAdvanced).slice(0, -2).length !== 0 ? String(yearlyPriceFormattedAdvanced).slice(0, -2) : 0,
                                                                        ".",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                            children: String(yearlyPriceFormattedAdvanced).slice(-2)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "font-300 mb-[2px] text-[10px] lowercase text-blue-600",
                                                                    children: [
                                                                        "/",
                                                                        t("txt_month"),
                                                                        "*"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                                                    gradient: true,
                                                    disabled: (0,subscription_popup/* getAdvancedButtonText */.JH)(currentPackId) === "txt_current_plan",
                                                    onClick: function() {
                                                        return handlePurchaseClick(advanced.variants[0].pack_id);
                                                    },
                                                    small: true,
                                                    className: "flex h-10 w-full items-center justify-center !p-0 !text-[12px] tablet:!text-[15px] desktop:w-[170px]",
                                                    text: (0,subscription_popup/* getAdvancedButtonText */.JH)(currentPackId)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    sections.map(function(section, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,clsx_m/* default */.Z)(sections.length - 1 === index && " rounded-b-[12px]", "flex w-full flex-col gap-[12px] bg-color-cell py-[14px]", "relative z-10 border-b border-color-separator tablet:pl-4 desktop:pl-[20px]"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: " pointer-events-none absolute -top-1 left-0 z-20 flex h-full w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "hidden flex-1 tablet:block"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(sections.length - 1 === index ? "rounded-b-[12px] border-2 border-t-0" : "border-x-2", "relative h-[calc(100%+5px)] w-full border-green-400 tablet:w-[172px] desktop:w-[209px]")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full tablet:w-[169px] desktop:w-[209px]"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (0,clsx_m/* default */.Z)("pl-3 text-[14px] font-700 uppercase tracking-[0.28px] tablet:pl-0", "text-blue-800"),
                                    children: section.title
                                }),
                                section.features.map(function(feature, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (0,clsx_m/* default */.Z)(index !== 0 && "border-t border-color-separator py-1 tablet:border-none", "flex w-full flex-col rounded-b-[12px] bg-color-cell", "tablet:flex-row tablet:py-3 desktop:py-4"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex w-[100px] items-center gap-1 tablet:w-auto tablet:flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,clsx_m/* default */.Z)("pl-3 text-start text-[14px] font-400 text-blue-600 tablet:w-auto tablet:pl-0 tablet:text-[18px] tablet:text-blue-700"),
                                                        children: feature.title
                                                    }),
                                                    feature.tooltip && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "peer",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                    width: "18",
                                                                    height: "18",
                                                                    viewBox: "0 0 18 18",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M8.99643 4.60958C9.40054 4.60958 9.72814 4.93717 9.72814 5.34128V9.45589C9.72814 9.86001 9.40054 10.1876 8.99643 10.1876C8.59232 10.1876 8.26472 9.86001 8.26472 9.45589V5.34128C8.26472 4.93717 8.59232 4.60958 8.99643 4.60958Z",
                                                                            fill: "var(--color-blue-900)"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            d: "M8.99634 11.5608C8.59223 11.5608 8.26463 11.8884 8.26463 12.2925C8.26463 12.6966 8.59223 13.0242 8.99634 13.0242H9.00366C9.40777 13.0242 9.73537 12.6966 9.73537 12.2925C9.73537 11.8884 9.40777 11.5608 9.00366 11.5608H8.99634Z",
                                                                            fill: "var(--color-blue-900)"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                            fillRule: "evenodd",
                                                                            clipRule: "evenodd",
                                                                            d: "M1.5 9C1.5 4.85833 4.85833 1.5 9 1.5C13.1425 1.5 16.5 4.85838 16.5 9C16.5 13.1416 13.1425 16.5 9 16.5C4.85833 16.5 1.5 13.1417 1.5 9ZM9 2.96341C5.66655 2.96341 2.96341 5.66655 2.96341 9C2.96341 12.3335 5.66655 15.0366 9 15.0366C12.3341 15.0366 15.0366 12.3335 15.0366 9C15.0366 5.6665 12.3341 2.96341 9 2.96341Z",
                                                                            fill: "var(--color-blue-900)"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: (0,clsx_m/* default */.Z)("absolute hidden peer-hover:flex", "bottom-[-12px] left-[-60px] z-50 translate-y-full"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (0,clsx_m/* default */.Z)("relative rounded-[8px] bg-blue-200 p-3", "flex w-[345px] items-center justify-center"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "text-[15px] font-400 text-blue-800",
                                                                            children: feature.tooltip
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (0,clsx_m/* default */.Z)("left-[63px] h-[10px] w-[10px] bg-blue-200", "absolute top-[-4px] rotate-45 rounded-[2px]")
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex w-full items-center tablet:w-auto",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,clsx_m/* default */.Z)(typeof feature.compareInfo.advanced === "string" && "text-center text-[14px] font-500 text-blue-900 tablet:text-[17px] tablet:text-blue-800", "flex w-full items-center justify-center text-center tablet:px-3", "tablet:w-[170px] desktop:w-[209px]"),
                                                        children: compareTransform(feature.compareInfo.basic)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (0,clsx_m/* default */.Z)(typeof feature.compareInfo.enterprise === "string" && "text-center text-[14px] font-500 text-blue-900 tablet:text-[17px] tablet:text-blue-800", "flex w-full items-center justify-center text-center tablet:px-3", "tablet:w-[170px] desktop:w-[209px]"),
                                                        children: compareTransform(feature.compareInfo.advanced)
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index);
                                })
                            ]
                        }, index);
                    })
                ]
            })
        ]
    });
}
var compareTransform = function(arg) {
    switch(arg){
        case "x":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "19",
                height: "18",
                viewBox: "0 0 19 18",
                fill: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.891 9.133C10.8557 9.09783 10.8359 9.05006 10.8359 9.00025C10.8359 8.95044 10.8557 8.90268 10.891 8.8675L17.8383 1.921C18.2775 1.48111 18.277 0.768399 17.8371 0.329126C17.3972 -0.110148 16.6845 -0.109644 16.2453 0.330251L9.29876 7.27375C9.26359 7.30902 9.21583 7.32884 9.16601 7.32884C9.1162 7.32884 9.06844 7.30902 9.03326 7.27375L2.08676 0.330251C1.64749 -0.10923 0.93512 -0.109398 0.495639 0.329876C0.0561589 0.769149 0.055991 1.48152 0.495264 1.921L7.44101 8.8675C7.47628 8.90268 7.4961 8.95044 7.4961 9.00025C7.4961 9.05006 7.47628 9.09783 7.44101 9.133L0.495264 16.0803C0.211104 16.3645 0.100199 16.7788 0.204325 17.1671C0.30845 17.5553 0.611789 17.8585 1.00007 17.9625C1.38836 18.0664 1.8026 17.9553 2.08676 17.671L9.03326 10.7238C9.06844 10.6885 9.1162 10.6687 9.16601 10.6687C9.21583 10.6687 9.26359 10.6885 9.29876 10.7238L16.2453 17.671C16.6845 18.1105 17.3969 18.1106 17.8364 17.6714C18.2759 17.2321 18.276 16.5197 17.8368 16.0803L10.891 9.133Z",
                    fill: "#FD2E2E"
                })
            });
        case "v":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "25",
                height: "24",
                viewBox: "0 0 25 24",
                fill: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M21.2927 5.3128C21.6723 5.71402 21.6547 6.34694 21.2535 6.72647L8.56774 18.7265C8.36889 18.9146 8.10163 19.0129 7.82829 18.9986C7.55495 18.9843 7.29941 18.8586 7.12128 18.6508L3.007 13.8508C2.64757 13.4315 2.69614 12.8002 3.11546 12.4407C3.53479 12.0813 4.16609 12.1299 4.52551 12.5492L7.95631 16.5518L19.8791 5.27353C20.2803 4.894 20.9132 4.91159 21.2927 5.3128Z",
                    fill: "#09C185"
                })
            });
        case "@":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M12 12C10 9.33 8 8 6 8C4.93913 8 3.92172 8.42143 3.17157 9.17157C2.42143 9.92172 2 10.9391 2 12C2 13.0609 2.42143 14.0783 3.17157 14.8284C3.92172 15.5786 4.93913 16 6 16C8 16 10 14.67 12 12ZM12 12C14 14.67 16 16 18 16C19.0609 16 20.0783 15.5786 20.8284 14.8284C21.5786 14.0783 22 13.0609 22 12C22 10.9391 21.5786 9.92172 20.8284 9.17157C20.0783 8.42143 19.0609 8 18 8C16 8 14 9.33 12 12Z",
                    stroke: "#09C185",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            });
        default:
            return arg // Return the string as is for any other case
            ;
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./comps/skeleton.tsx
var skeleton = __webpack_require__(4165);
// EXTERNAL MODULE: ./utils/login-redirect.tsx
var login_redirect = __webpack_require__(7592);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(8767);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
// EXTERNAL MODULE: ./sections/pricing/render-block.tsx
var render_block = __webpack_require__(2612);
;// CONCATENATED MODULE: ./sections/pricing/pricing-or-coin.tsx






















function fetchPrices() {
    return _fetchPrices.apply(this, arguments);
}
function _fetchPrices() {
    _fetchPrices = (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        axios/* default.get */.Z.get("/api/payment-coin-packs").then(function(res) {
                            return res.data;
                        })
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _fetchPrices.apply(this, arguments);
}
function PricingOrCoin(props) {
    var handleCoinsPurchase = function handleCoinsPurchase() {
        if (userInfo.isAnonymous) {
            (0,login_redirect/* redirectToLogin */.r)();
        } else {
            handlePurchase();
        }
    };
    var activeState = props.activeState, isYearly = props.isYearly, setIsMonthly = props.setIsMonthly, plans = props.plans, savePercent = props.savePercent, handlePurchaseClick = props.handlePurchaseClick, basic = props.basic, advanced = props.advanced;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react.useState)(false), isProcessing = ref1[0], setIsProcessing = ref1[1];
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var userInfo = (0,client_auth/* useAuth */.aC)().userInfo;
    var router = (0,next_router.useRouter)();
    function handlePurchase() {
        return _handlePurchase.apply(this, arguments);
    }
    function _handlePurchase() {
        _handlePurchase = (0,_async_to_generator/* default */.Z)(function() {
            var sessionId, payload, ref, url, value, currency, paymentData, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!selected) {
                            return [
                                2
                            ];
                        }
                        setIsProcessing(true);
                        sessionId = (0,v4/* default */.Z)();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        payload = {
                            id: selected,
                            location: router.asPath,
                            sessionId: sessionId
                        };
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/payment-pack-url", payload).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), url = ref.url, value = ref.value, currency = ref.currency;
                        paymentData = {
                            value: value,
                            currency: currency,
                            session: sessionId
                        };
                        localStorage.setItem(adjust/* PAYMENT_DATA_KEY */.kV, JSON.stringify(paymentData));
                        return [
                            4,
                            router.push(url)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        console.error(e);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("txt_cannot_buy_now")
                        }));
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setIsProcessing(false);
                        return [
                            2
                        ];
                }
            });
        });
        return _handlePurchase.apply(this, arguments);
    }
    var CACHE_MINUTES = 10;
    var prices = (0,es.useQuery)({
        queryKey: [
            "coins",
            "prices",
            userInfo === null || userInfo === void 0 ? void 0 : userInfo.userId
        ],
        queryFn: fetchPrices,
        enabled: userInfo !== null,
        staleTime: Infinity,
        cacheTime: CACHE_MINUTES * 60 * 1000
    });
    (0,react.useEffect)(function() {
        if (!prices.data) {
            return;
        }
        if (selected) {
            return;
        }
        var popular = prices.data.find(function(price) {
            return price.popular;
        });
        if (popular) {
            setSelected(popular.id);
        }
    }, [
        prices,
        selected
    ]);
    switch(activeState){
        case "pricing":
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx_m/* default */.Z)("flex w-full flex-col items-center", "pt-[44px] tablet:pt-[30px] desktop:pt-[42px] "),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex gap-[10px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-500" : "text-blue-900", "text-[18px] font-500 transition-colors"),
                                children: t("txt_monthly")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle/* SquareSwitch */.ZP, {
                                onChange: setIsMonthly,
                                enabled: isYearly
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(isYearly ? "text-blue-900" : "text-blue-500", "text-[18px] font-500 transition-colors "),
                                children: t("txt_yearly")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)("text-[18px] font-500 transition-colors", isYearly ? "text-blue-900" : "text-blue-500"),
                                children: t("fs_save_percent", {
                                    percent: String(savePercent)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(render_block/* default */.Z, {
                        plans: plans,
                        isYearly: isYearly,
                        handlePurchaseClick: handlePurchaseClick,
                        basic: basic,
                        advanced: advanced
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (0,clsx_m/* default */.Z)("pt-4 text-[16px] font-400 text-blue-500 transition-opacity", isYearly ? "opacity-100" : "opacity-0"),
                        children: [
                            "*",
                            t("txt_billed_yearly")
                        ]
                    })
                ]
            });
        case "coin":
            var ref2;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " flex w-full flex-col items-center gap-[32px] pt-[62px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (0,clsx_m/* default */.Z)("grid w-full max-w-[344px] grid-cols-2 px-[20px] tablet:max-w-none", " tablet:w-[582px] desktop:w-[775px] desktop:grid-cols-3 desktop:px-0"),
                        children: [
                            (ref2 = prices.data) === null || ref2 === void 0 ? void 0 : ref2.map(function(price) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceOption, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, price), {
                                    selected: price.id === selected,
                                    onSelected: function() {
                                        if (!userInfo || userInfo.isAnonymous) {
                                            setSelected(price.id);
                                            (0,login_redirect/* redirectToLogin */.r)();
                                            return;
                                        }
                                        if (selected === price.id) {
                                            handlePurchase();
                                        } else {
                                            setSelected(price.id);
                                        }
                                    }
                                }), price.id);
                            }),
                            prices.isFetching && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                        className: (0,clsx_m/* default */.Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px]", " tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                        className: (0,clsx_m/* default */.Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px]", " tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                        className: (0,clsx_m/* default */.Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px]", " tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                        className: (0,clsx_m/* default */.Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px]", " tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                        className: (0,clsx_m/* default */.Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px]", "tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton/* SizedSkeleton */.xB, {
                                        className: (0,clsx_m/* default */.Z)("h-[72px] flex-1 rounded-[4px] inner-border tablet:h-[145px] tablet:w-[200px]", "tablet:flex-none tablet:rounded-[12px]", "basis-1/4 bg-color-cell inner-border-blue-200")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(comps_button/* default */.ZP, {
                        text: t("txt_purchase_coins"),
                        disabled: !prices.isSuccess || isProcessing,
                        onClick: handleCoinsPurchase,
                        primary: true
                    })
                ]
            });
    }
}
function PriceOption(props) {
    var coins = props.coins, price = props.price, popular = props.popular, best = props.best, selected = props.selected, onSelected = props.onSelected;
    var t = (0,esm/* useTranslation */.$G)().t;
    var priceTag = (price / 100).toFixed(2);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        onClick: onSelected,
        className: (0,clsx_m/* default */.Z)("relative flex w-full flex-col items-center justify-center", "h-[110px] rounded-[4px] inner-border tablet:h-[148px] tablet:flex-none", selected ? "bg-primary-100 inner-border-primary-500" : "bg-color-cell inner-border-blue-200", "basis-1/4 transition-all"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[13px] font-700 text-blue-800 tablet:text-[22px]",
                                children: coins.toLocaleString()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: (0,cdn/* assetUrl */.p)("/general/coin.svg"),
                                alt: "coin icon",
                                className: "aspect-square pointer-events-none w-5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (0,clsx_m/* default */.Z)("text-[12px] tablet:text-[18px]", selected ? "text-blue-800" : "text-blue-600"),
                        children: [
                            "$",
                            priceTag
                        ]
                    })
                ]
            }),
            popular && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("absolute right-2 top-2", "rounded-[4px] tablet:rounded-[12px] tablet:rounded-tr-none", "px-1 tablet:px-4", "text-[8px] tablet:text-[10px]", "font-700 uppercase text-color-white", " bg-primary-500"),
                children: t("lbl_popular")
            }),
            best && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)("absolute right-2 top-2 bg-primary-100", "rounded-[4px] tablet:rounded-[12px]", "px-1 tablet:px-4", "text-[8px] tablet:text-[10px]", "font-700 uppercase text-primary-500"),
                children: t("lbl_best")
            })
        ]
    });
}

;// CONCATENATED MODULE: ./sections/pricing/question.tsx



function Question(props) {
    var question = props.question, answer = props.answer;
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)("flex w-full shrink-0 flex-col overflow-hidden rounded-[10px] bg-color-cell", "tablet:w-[572px] desktop:w-[729px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                onClick: function() {
                    return setOpen(!open);
                },
                className: (0,clsx_m/* default */.Z)("flex cursor-pointer select-none flex-row items-center justify-between p-4", open && "border-b border-color-separator"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (0,clsx_m/* default */.Z)("text-body-3 transition-colors duration-300", open && "text-primary-500"),
                        children: question
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "button relative max-h-[16px] min-h-[16px] min-w-[16px] max-w-[16px] cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(open && "rotate-90", "before-line absolute bg-blue-400 transition-transform duration-[250ms] ease-out")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,clsx_m/* default */.Z)(open ? "bg-primary-500" : "bg-blue-400", "after-line absolute transition-transform duration-[250ms] ease-out")
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (0,clsx_m/* default */.Z)(open ? "text-body-5 max-h-[200px] overflow-y-hidden p-5 opacity-100 duration-300 ease-in-out" : "text-body-5 max-h-0 overflow-hidden px-5 py-0 opacity-0 duration-300 ease-in-out", "transition-max-h"),
                children: answer
            })
        ]
    });
}

// EXTERNAL MODULE: ./utils/coins.tsx
var coins = __webpack_require__(279);
// EXTERNAL MODULE: ./utils/scrollto.ts
var scrollto = __webpack_require__(1634);
;// CONCATENATED MODULE: ./sections/pricing/subscription-details.tsx







function SubscriptionDetails() {
    var ref;
    var t = (0,esm/* useTranslation */.$G)().t;
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var currentPlan = (0,subscription_popup/* getCurrentPlan */.MX)(userInfo.entitlements);
    var wallet = (0,coins/* useCoins */.YO)();
    var ref1;
    var targetDate = new Date((ref1 = wallet === null || wallet === void 0 ? void 0 : (ref = wallet.renewInfo) === null || ref === void 0 ? void 0 : ref.date) !== null && ref1 !== void 0 ? ref1 : "").getTime();
    var currentDate = new Date().getTime();
    var differenceMs = targetDate - currentDate;
    var daysLeft = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)(" flex w-full flex-col items-center justify-center gap-5 px-4 transition-all duration-300", !wallet || !wallet.renewInfo ? "pointer-events-none h-[0px] overflow-hidden" : "mt-[50px] h-[340px] tablet:h-[320px] desktop:h-[325px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-[18px] font-700 text-blue-900 tablet:text-[20px] desktop:text-[28px]",
                children: t("txt_subscription_details")
            }),
            wallet && wallet.renewInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex w-full flex-col items-center justify-center gap-1 desktop:w-[775px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("flex w-full flex-col gap-5 rounded-[12px] bg-color-cell px-6 py-[18px] desktop:w-[775px]", "[box-shadow:0px_5px_12px_0px_rgba(183,183,183,0.12)] dark:[box-shadow:unset]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center gap-[22px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-500 text-blue-600",
                                        children: t("txt_current_plan")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-500 text-blue-800",
                                        children: currentPlan
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[1px] w-full bg-color-separator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center gap-[22px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-500 text-blue-600",
                                        children: t("txt_renew_date")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-[16px] font-500 text-blue-800",
                                        children: wallet.renewInfo.cancelled ? "-" : new Date(wallet.renewInfo.date).toLocaleDateString("en-US", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "h-[1px] w-full bg-color-separator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-3 tablet:gap-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col items-start justify-between gap-1 tablet:flex-row tablet:items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[16px] font-500 text-blue-600",
                                                children: t("txt_available_tokens")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-[12px] font-400 text-blue-500",
                                                children: t("fs_tokens_left", {
                                                    temporary_tokens: (ref2 = (wallet.temporaryTokens + wallet.permanentTokens).toLocaleString()) !== null && ref2 !== void 0 ? ref2 : 0,
                                                    tokens: (ref3 = (wallet.renewInfo.tokens + wallet.permanentTokens).toLocaleString()) !== null && ref3 !== void 0 ? ref3 : 0,
                                                    days: daysLeft
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative flex h-1 w-full overflow-hidden rounded-[10px] bg-blue-200",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            style: {
                                                width: "".concat((wallet.temporaryTokens + wallet.permanentTokens) / (wallet.renewInfo.tokens + wallet.permanentTokens) * 100, "%")
                                            },
                                            className: (0,clsx_m/* default */.Z)("absolute left-0 top-0 h-full transition-all", (wallet.temporaryTokens + wallet.permanentTokens) / (wallet.renewInfo.tokens + wallet.permanentTokens) * 100 > 15 ? "bg-color-success" : "bg-color-error")
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex w-full flex-row items-center justify-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                (0,scrollto/* scrollToSection */.Q)("pricing")();
                                            },
                                            className: "hover:bg-primary-600/10 flex flex-row items-center gap-1 rounded-[4px] px-2 py-1 transition-colors",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "relative h-[10px] w-[10px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute left-0 top-1/2 h-[1.5px] w-full rounded-sm bg-primary-500"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "absolute left-0 top-1/2 h-[1.5px] w-full rotate-90 rounded-sm bg-primary-500"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-[12px] font-600 text-primary-500",
                                                    children: t("txt_add_tokens")
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex w-full items-start justify-start px-1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: function(e) {
                                e.preventDefault();
                                (0,scrollto/* scrollToSection */.Q)("pricing")();
                            },
                            className: "text-[14px] font-500 text-blue-500",
                            children: t("txt_change_plan")
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./statics/offering-info.json
var offering_info_namespaceObject = JSON.parse('{"packages":[{"id":"plan_basic_5","sale":45,"title":"Basic","img_url":"https://filesw.zoomerang.info/image/0PurchaseScreen/plan_basic_image.webp","entitlements":["pro","removeWatermark","removeAds","checkmark"],"subs_packages":["basic_yearly"],"short_keypoints":["All Prime templates, filters, effects & AI tools","No watermark & ads"],"def_selected_package":"basic_yearly"},{"id":"plan_advanced_10","sale":25,"title":"Advanced","img_url":"https://filesw.zoomerang.info/image/0PurchaseScreen/plan_advanced_image.webp","best_for_ai":true,"entitlements":["pro","removeWatermark","removeAds","ai_coin_free","ai_concurrent_jobs","checkmark","brandkit"],"limited_time":true,"subs_packages":["advanced_yearly","advanced_monthly"],"short_keypoints":["Everything in Basic plan","AI tools (unlimited)","Simultaneous AI Jobs"],"def_selected_package":"advanced_yearly"}],"package_compare":{"packages":[{"id":"free","title":"Free","plan_id":"free"},{"id":"basic","title":"Basic","plan_id":"plan_basic_5"},{"id":"advanced","title":"Advanced","plan_id":"plan_advanced_10"}],"sections":[{"title":"Features","features":[{"title":"AI Chat","package_info":{"free":"v","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Free Stock Assets","package_info":{"free":"v","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Mobile Video Editor","package_info":{"free":"v","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Gen AI","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}}]},{"title":"AI Art","features":[{"title":"AI Product Photoshoot","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Text to Video","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Text to Image","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"},"tooltip":"Average quality for Pro, high quality for Advanced without extra coins."},{"title":"AI Music Generator","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"AI Photo Art","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"},"tooltip":"Average quality for Pro, high quality for Advanced without extra coins."},{"title":"Generative Fill (Beta)","package_info":{"free":"x","basic":"v","advanced":"@","enterprise":"v"}},{"title":"Model Photoshoot","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Expand AI","package_info":{"free":"x","basic":"v","advanced":"@","enterprise":"v"},"tooltip":"Average quality for Pro, high quality for Advanced without extra coins."},{"title":"Deform AI","package_info":{"free":"x","basic":"v","advanced":"@","enterprise":"v"},"tooltip":"Duration up to 5 sec for Pro, up to 10 sec for Advanced. Average quality for Pro, high quality for Advanced without extra coins."},{"title":"Restyle AI","package_info":{"free":"x","basic":"v","advanced":"@","enterprise":"v"},"tooltip":"Duration up to 1 sec for Pro, up to 30 sec for Advanced. Average quality for Pro, high quality for Advanced without extra coins."},{"title":"Parallel AI Session","package_info":{"free":"x","basic":"1","advanced":"Up to 3","enterprise":"v"}}]},{"title":"Other","features":[{"title":"Mobile App Pro Features","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Verified Badge","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Remove Ads","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Remove Watermark","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"Marketplace Assets","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"All Prime Templates","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}}]},{"title":"Video AI","features":[{"title":"Product URL to Video","package_info":{"free":"x","basic":"v","advanced":"v","enterprise":"v"}},{"title":"AI UGC Actors","package_info":{"free":"8 Actors","basic":"90+ Actors","advanced":"90+ Actors","enterprise":"90+ Actors"}},{"title":"AI Voiceover Artists","package_info":{"free":"4","basic":"44+","advanced":"44+","enterprise":"44+"}},{"title":"AI Script Generator","package_info":{"free":"v","basic":"v","advanced":"v","enterprise":"v"}}]},{"title":"Support","features":[{"title":"Customer Support","package_info":{"free":"v","basic":"v","advanced":"v","enterprise":"v"}}]}]},"available_plans":[{"id":"plan_basic_5","title":"Basic","weight":0},{"id":"plan_advanced_10","title":"Pro","weight":5}]}');
// EXTERNAL MODULE: ./statics/offering-prices.json
var offering_prices = __webpack_require__(8753);
;// CONCATENATED MODULE: ./pages/pricing/index.tsx


























var prices = subscription_popup/* pricesSchema.parse */.R3.parse(offering_prices);
var plansParsed = subscription_popup/* plansSchema.parse */.MJ.parse(offering_info_namespaceObject);
var comparePlans = transformProps(plansParsed);
var __N_SSP = true;
function Pricing(props) {
    var plans = props.plans;
    var packageCompare = comparePlans.result.packageCompare;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(props.currentTab), activeState = ref[0], setActiveState = ref[1];
    var userInfo = (0,client_auth/* default */.ZP)().userInfo;
    var router = (0,next_router.useRouter)();
    var notify = (0,react.useContext)(notification/* NotificationContext */.u).notify;
    var logAdjust = (0,adjust/* useAdjustLogger */.eW)();
    var ref1 = (0,react.useState)(true), isYearly = ref1[0], setIsMonthly = ref1[1];
    function handlePurchaseClick(packId) {
        return _handlePurchaseClick.apply(this, arguments);
    }
    function _handlePurchaseClick() {
        _handlePurchaseClick = (0,_async_to_generator/* default */.Z)(function(packId) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (userInfo && !userInfo.isAnonymous) {
                    fetchPaymentLink(packId);
                } else {
                    router.push("/login");
                }
                return [
                    2
                ];
            });
        });
        return _handlePurchaseClick.apply(this, arguments);
    }
    function fetchPaymentLink(packId) {
        return _fetchPaymentLink.apply(this, arguments);
    }
    function _fetchPaymentLink() {
        _fetchPaymentLink = (0,_async_to_generator/* default */.Z)(function(packId) {
            var sessionId, payload, _tmp, ref, url, currency, value, paymentData, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        sessionId = (0,v4/* default */.Z)();
                        _tmp = {
                            location: router.asPath,
                            period: isYearly ? "yearly" : "monthly"
                        };
                        return [
                            4,
                            (0,subscription_popup/* getAdId */.YF)()
                        ];
                    case 1:
                        payload = (_tmp.adId = _state.sent(), _tmp.sessionId = sessionId, _tmp.offering = packId, _tmp);
                        return [
                            4,
                            axios/* default.post */.Z.post("/api/payment-stripe-url", payload).then(function(res) {
                                return res.data;
                            })
                        ];
                    case 2:
                        ref = _state.sent(), url = ref.url, currency = ref.currency, value = ref.value;
                        logAdjust === null || logAdjust === void 0 ? void 0 : logAdjust.logEvent("initiate_checkout");
                        paymentData = {
                            currency: currency,
                            value: value,
                            session: sessionId
                        };
                        localStorage.setItem(adjust/* PAYMENT_DATA_KEY */.kV, JSON.stringify(paymentData));
                        router.push(url);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        notify(/*#__PURE__*/ (0,jsx_runtime.jsx)(message/* ErrorMessage */.Bc, {
                            children: t("txt_could_not_purchase_now")
                        }));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        window.blur();
                        return [
                            2
                        ];
                }
            });
        });
        return _fetchPaymentLink.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(meta/* default */.Z, {
                title: t("txt_plan_and_pricing"),
                description: t("txt_home_description")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-screen w-full",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.ZP, {
                            isStatic: true
                        })
                    }),
                    !userInfo.isAnonymous && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionDetails, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex w-full flex-col items-center justify-center gap-5 pt-[50px] tablet:gap-8 tablet:px-5 desktop:gap-[61px] desktop:pt-[100px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "w-[250px] text-center text-[20px] font-700 text-blue-900 tablet:w-[300px] tablet:text-[24px] desktop:w-[400px] desktop:text-[32px]",
                                children: t("txt_pricing_title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                id: "pricing",
                                className: "flex w-full flex-col gap-3 tablet:w-[512px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex w-full flex-row items-center justify-between tablet:justify-center tablet:gap-[10px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setActiveState("pricing");
                                                },
                                                className: (0,clsx_m/* default */.Z)("flex w-1/2 items-center justify-center text-[14px] transition-all tablet:w-[251px] tablet:text-[18px]", activeState === "pricing" ? "font-700 text-blue-900" : "font-600 text-blue-500"),
                                                children: t("txt_business_plans")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function(e) {
                                                    e.preventDefault();
                                                    setActiveState("coin");
                                                },
                                                className: (0,clsx_m/* default */.Z)("flex w-1/2 items-center justify-center text-[14px] transition-all tablet:w-[251px] tablet:text-[18px]", activeState === "coin" ? "font-700 text-blue-900" : "font-600 text-blue-500"),
                                                children: t("txt_coins")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative h-[1px] w-full bg-blue-300",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)("absolute top-[-0.5px] h-[2px] w-1/2 bg-blue-900 transition-all duration-300 tablet:w-[251px]", activeState === "pricing" ? "left-0" : "left-1/2 tablet:left-[261px]")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingOrCoin, {
                        activeState: activeState,
                        isYearly: isYearly,
                        setIsMonthly: setIsMonthly,
                        plans: prices.plans,
                        savePercent: prices.save_percent,
                        handlePurchaseClick: handlePurchaseClick,
                        basic: plans.plans.basic,
                        advanced: plans.plans.advanced
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(runner["default"], {
                        className: "mt-[32px] tablet:mt-[60px] desktop:mt-[100px]",
                        bgColor: "background"
                    }),
                    activeState === "pricing" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Compare, {
                        sections: packageCompare.sections,
                        packages: packageCompare.packages,
                        isYearly: isYearly,
                        setIsMonthly: setIsMonthly,
                        handlePurchaseClick: handlePurchaseClick,
                        savePercent: prices.save_percent,
                        basic: plans.plans.basic,
                        advanced: plans.plans.advanced
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(activeState === "coin" ? "desktop:pb-0" : "desktop:pb-[40px]", "flex w-full items-center justify-center pt-[48px]"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: (0,cdn/* assetUrl */.p)("/general/editor-choice.svg"),
                            alt: "editor choice",
                            className: "h-[60px] w-[100px]"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)(activeState === "coin" && "hidden", "flex w-full flex-col items-center gap-[32px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-[24px] font-700",
                                children: t("txt_we_trust")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("no-scrollbar flex w-full gap-[20px] overflow-x-scroll", "px-[20px] tablet:justify-center desktop:items-center"),
                                children: prices.reviews.map(function(review, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(reviews/* SingleReview */.il, {
                                        review: {
                                            name: review.name,
                                            rating: review.stars,
                                            opinion: review.text,
                                            avatar: review.image
                                        },
                                        avatar: review.image
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,clsx_m/* default */.Z)("flex w-full flex-col items-center gap-[30px] py-[60px]", "desktop:flex-row desktop:items-start desktop:justify-center desktop:gap-[24px]", "desktop:pt-[110px]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-h5 desktop:w-[272px]",
                                children: t("txt_asked_questions")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,clsx_m/* default */.Z)("flex w-full flex-col gap-[16px] px-[20px] desktop:w-[775px] desktop:p-0", "no-scrollbar max-h-[724px] overflow-y-scroll tablet:items-center"),
                                children: prices.faq.map(function(question, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Question, {
                                        question: question.q,
                                        answer: question.a
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* WrappedFooter */.M, {})
                    })
                ]
            })
        ]
    });
}
function transformProps(plans) {
    var camelCasePlans = {
        result: {
            packages: plans.packages.map(function(packageItem) {
                return {
                    id: packageItem.id,
                    title: packageItem.title,
                    bestForAI: packageItem.best_for_ai
                };
            }),
            packageCompare: {
                packages: plans.package_compare.packages.map(function(packageItem) {
                    return {
                        id: packageItem.id,
                        title: packageItem.title
                    };
                }),
                sections: plans.package_compare.sections.map(function(section) {
                    return {
                        title: section.title,
                        features: section.features.map(function(feature) {
                            return {
                                title: feature.title,
                                compareInfo: {
                                    free: feature.package_info.free,
                                    basic: feature.package_info.basic,
                                    advanced: feature.package_info.advanced,
                                    enterprise: feature.package_info.enterprise
                                },
                                tooltip: feature.tooltip
                            };
                        })
                    };
                })
            },
            availablePlans: plans.available_plans.map(function(availablePlan) {
                return {
                    id: availablePlan.id,
                    title: availablePlan.title,
                    weight: availablePlan.weight
                };
            })
        }
    };
    return camelCasePlans;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4593,2612,9774,2888,179], function() { return __webpack_exec__(3542); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);